import * as TK from 'pages/ForgotPasswordPage/translations/constants';
import { Translations } from 'translations/types';

export const forgotPasswordPageEnUsLocale: Translations = {
  [TK.FORGOT_PASSWORD_PAGE_TITLE]: 'Forgot password',
  [TK.FORGOT_PASSWORD_PAGE_DESCRIPTION]: 'Please enter your email address to request a password reset.',
  [TK.FORGOT_PASSWORD_PAGE_ICON_ALT]: 'Forgot password icon',
};
